import connect from 'components/lib/connect';
import StartUpload from 'actions/knowledge_base/start_upload';
import SlateStylesMenu from './slate_styles_menu';

const mapStateToProps = (context, props) => {
  const snippet = context.getProvider('snippetComposition').get();
  const snippetId = snippet && snippet.id;
  return { snippetId, ...props };
};

const mapExecuteToProps = (executeAction, props) => {
  function onStartUpload(file, contentChannelType, onInsertImage, isInline) {
    executeAction(StartUpload, { file, contentChannelType, onInsertImage, isInline, language: props.language });
  }

  return { onStartUpload };
};

export default connect(mapStateToProps, mapExecuteToProps)(SlateStylesMenu);



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/composition/lib/slate/slate_styles_menu_container.jsx